import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as CustomFieldsActions from './custom-fields.actions';
import { CustomFieldsEntity } from './custom-fields.models';

export const CUSTOMFIELDS_FEATURE_KEY = 'customFields';

export interface State extends EntityState<CustomFieldsEntity> {
    selectedId?: string | number; // which CustomFields record has been selected
    loading: boolean; // has the CustomFields list been loaded
    error?: string | null; // last known error (if any)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    query: any;
}

export interface CustomFieldsPartialState {
    readonly [CUSTOMFIELDS_FEATURE_KEY]: State;
}

export const customFieldsAdapter: EntityAdapter<CustomFieldsEntity> =
    createEntityAdapter<CustomFieldsEntity>();

export const initialState: State = customFieldsAdapter.getInitialState({
    // set initial required properties
    loading: false,
    query: {},
});

const customFieldsReducer = createReducer(
    initialState,
    on(CustomFieldsActions.init, (state, { query }) => ({
        ...state,
        loaded: true,
        error: null,
        query: {
            ...state.query,
            ...query,
        },
    })),
    on(CustomFieldsActions.loadCustomFieldsSuccess, (state, { customFields }) =>
        customFieldsAdapter.setAll(customFields, {
            ...state,
            loading: false,
        })
    ),
    on(CustomFieldsActions.loadCustomFieldsFailure, (state, { error }) => ({
        ...state,
        error,
        loading: false,
    })),
    on(CustomFieldsActions.reset, () => initialState)
);

export function reducer(state: State | undefined, action: Action) {
    return customFieldsReducer(state, action);
}
